import React, { useEffect, useState } from 'react';
import { DataGridComplete, DataGridRow } from 'components/DataGrid';
import Checkbox from 'components/Buttons/CheckboxButton';
import actions from 'state/actions';
import { useDispatch } from 'react-redux';

export interface Props {
  row: DataGridRow;
  focus: boolean;
  code: number;
  predictionsValuesBody: DataGridRow[];
  disabled?: boolean;
}

const CellPredictionBooleanInput = ({ row, code, predictionsValuesBody, disabled }: Props) => {
  const [value, setValue] = useState<boolean>(false);
  const fieldValue = predictionsValuesBody?.find(({ id }) => id === row.id);
  const dispatch = useDispatch();

  useEffect(() => {
    if (fieldValue) {
      const valueCode = fieldValue[code]?.content;
      if (valueCode) setValue(valueCode === 'true');
    }
  }, [code, predictionsValuesBody, row.id, fieldValue]);

  const onFieldChange = (value: boolean, rowId: string, fieldId: string | number) => {
    let actualPredictionBody: DataGridRow | null = null;
    const body = predictionsValuesBody?.map((elem: DataGridComplete) => {
      if (elem.id === rowId) {
        actualPredictionBody = {
          ...elem,
          [fieldId]: { content: value ? 'true' : 'false' },
        };
        return actualPredictionBody;
      }
      return elem;
    });
    setValue(value);
    dispatch(actions.documents.setFormattedPredictionsData(body));
    dispatch(actions.documents.setSelectedPredictionsRow(actualPredictionBody));
  };

  return <Checkbox isActive={value} isEditable={!disabled} action={(value) => onFieldChange(value, row.id, code)} />;
};

export default CellPredictionBooleanInput;
